import { Component, Input, OnInit, OnChanges, SimpleChanges, Injector } from '@angular/core';
import { KindBoard } from 'src/utils/enums';
import { PageBase } from '../shared/library/page.base';

@Component({
    selector: 'cp-donutchart',
    templateUrl: './cp-donutchart.component.html',
    styleUrls: ['./cp-donutchart.component.css'],
    standalone: false
})
export class CpDonutchartComponent extends PageBase implements OnInit, OnChanges {

  @Input() value: number;
  @Input() Kind: KindBoard;
  radius = 44;
  circumference = 2 * Math.PI * this.radius;
  dashoffset: number;
  strokeColor: string;

  constructor(public objInjector: Injector)
  {
    super(objInjector);
    this.progress(0);
  }

  ngOnInit() {
    super.ngOnInit();
    if(this.Kind){
      if(this.Kind.valueOf() == KindBoard.Tarefa.valueOf())
      {
        this.strokeColor = "#277099";
      }
      else
      {
        this.strokeColor = "#32285C";
      }
    }
    else
    {
      this.strokeColor = "#277099";
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value.currentValue !== changes.value.previousValue) {
      this.progress(changes.value.currentValue);
    }
  }

  private progress(value: number) {
    value = this.validateValue(value);
    const progress = value / 100;
    this.dashoffset = this.circumference * (1 - progress);
  }

  private validateValue(value: number) {
    if (value > 100) {
      value = 100;
    }
    if (value < 0) {
      value = 0;
    }
    return value;
  }

  onReceiveLiterals(): void {}

}
